








import Vue, { PropType } from 'vue'

export default Vue.extend({
  props: {
    isGiftCard: Boolean,
    closeout: Boolean,
    icon: String,
  },
  computed: {
    backgroundUrl () {
      if (this.isGiftCard) {
        return `url(/img/icons/gift_card.jpg)`
      }

      return `url(/img/icons/${this.icon})`
    }
  }
})
